import { createContext, useContext, useState } from 'react';

const BreadcrumbsContext = createContext(null);

export function BreadcrumbsProvider({ children }) {
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    return (
        <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
            {children}
        </BreadcrumbsContext.Provider>
    );
}

export function useBreadcrumbs() {
    return useContext(BreadcrumbsContext);
}
